import { rem } from "./auth-service-tools172.js";
import "react";
import "./auth-service-tools177.js";
import { colorResolver } from "./auth-service-tools536.js";

function borderResolver(value, theme) {
  if (typeof value === "number") {
    return rem(value);
  }

  if (typeof value === "string") {
    const [size, style, ...colorTuple] = value.split(" ").filter(val => val.trim() !== "");
    let result = `${rem(size)}`;
    style && (result += ` ${style}`);
    colorTuple.length > 0 && (result += ` ${colorResolver(colorTuple.join(" "), theme)}`);
    return result.trim();
  }

  return value;
}

export { borderResolver };